import { css } from '@emotion/react';

export const sectionStyles = css`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;